<template lang="pug">
.modal.fade.show(style="display: block; background-color: rgba(0,0,0,0.5);")
  .modal-dialog.modal-fullscreen
    .modal-content
      .modal-header.sticky-header
        h5.modal-title クリック一覧
        button.btn-close(type="button" @click="closeModal" aria-label="Close")
          i.fas.fa-times
      .modal-body
        .row.mb-3.sticky-info
          .col-md-4
            p.mb-1
              strong 期間:
              | {{ formatDate(dateFrom) }} ～ {{ formatDate(dateTo) }}
          .col-md-4
            .form-group.mb-2
              label.form-label.small URL絞り込み
              .input-group
                input.form-control.form-control-sm(
                  type="text"
                  ref="filterInput"
                  placeholder="URLを入力（2文字以上）"
                  @keyup.enter="applyFilter"
                )
                button.btn.btn-outline-secondary.btn-sm(
                  type="button"
                  @click="applyFilter"
                )
                  i.fas.fa-search
                button.btn.btn-outline-danger.btn-sm(
                  type="button"
                  @click="clearFilter"
                  v-if="isFiltered"
                )
                  i.fas.fa-times
          .col-md-4.text-end
            p.mb-1
              strong 総クリック数:
              | {{ filteredTotalClicks.toLocaleString() }}
            button.btn.btn-success.btn-sm.mt-1(@click="downloadCsv")
              i.fas.fa-download.me-1
              | CSVダウンロード
        .loading-container(v-if="isLoading")
          .d-flex.justify-content-center.align-items-center.py-5
            .spinner-border.text-primary(role="status")
              span.visually-hidden
            span.ms-3 データを読み込み中...
        .table-container.px-0(v-else)
          table.table.table-striped.table-hover
            thead.table-dark.sticky-table-header
              tr
                th.rank-column(scope="col") 順位
                th.url-column(scope="col") クリック先URL
                th.count-column(scope="col") クリック数
                th.pv-ratio-column(scope="col") %(PV)
                th.click-ratio-column(scope="col") %(合計クリック)
            tbody
              tr(v-if="displayData.length === 0")
                td.text-center(colspan="5") {{ isFiltered ? 'フィルター条件に一致するデータがありません' : 'データがありません' }}
              tr(v-for="(log, index) in displayData" :key="index")
                td.rank-column {{ index + 1 }}
                td.url-column
                  a.url-link(:href="log.link_url" target="_blank" rel="noopener noreferrer") {{ log.link_url }}
                td.count-column.text-end {{ log.click_count.toLocaleString() }}
                td.pv-ratio-column.text-end {{ calculatePvRatio(log.click_count) }}%
                td.click-ratio-column.text-end {{ calculateClickRatio(log.click_count) }}%
      .modal-footer.sticky-footer
        button.btn.btn-secondary(type="button" @click="closeModal") 閉じる
</template>

<script>
export default {
  props: {
    state_name: {
      type: String,
      default: 'heatmap'
    }
  },
  data() {
    return {
      filteredData: [],
      currentFilter: '',
      isFilterApplied: false
    };
  },

  methods: {
    closeModal() {
      this.$store.commit(`${this.state_name}/setShowClickLinkLogsModal`, false);
      // モーダルを閉じる時にローディング状態をリセット
      this.$store.commit(`${this.state_name}/setClickLinkLogsLoading`, false);
      // フィルターもリセット
      this.clearFilter();
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    },
    calculatePvRatio(clickCount) {
      const totalPv = this.totalPv;
      if (totalPv === 0) return '0.000';
      return ((clickCount / totalPv) * 100).toFixed(3);
    },
    calculateClickRatio(clickCount) {
      const totalClicks = this.totalClicks;
      if (totalClicks === 0) return '0.000';
      return ((clickCount / totalClicks) * 100).toFixed(3);
    },
    applyFilter() {
      const inputValue = this.$refs.filterInput.value.trim();
      if (inputValue.length >= 2) {
        this.currentFilter = inputValue;
        this.isFilterApplied = true;
        this.filteredData = this.clickLinkLogs.filter(log =>
          log.link_url.toLowerCase().includes(inputValue.toLowerCase())
        );
      } else {
        alert('2文字以上入力してください。');
      }
    },
    clearFilter() {
      this.filteredData = [];
      this.currentFilter = '';
      this.isFilterApplied = false;
      if (this.$refs.filterInput) {
        this.$refs.filterInput.value = '';
      }
    },
    downloadCsv() {
      const data = this.displayData;
      if (data.length === 0) {
        alert('ダウンロードするデータがありません。');
        return;
      }

      // CSVヘッダー
      const headers = ['順位', 'クリック先URL', 'クリック数', '%(PV)', '%(合計クリック)'];

      // CSVデータ作成
      const csvContent = [
        headers.join(','),
        ...data.map((log, index) => [
          index + 1,
          `"${log.link_url.replace(/"/g, '""')}"`, // URLをダブルクォートで囲み、内部のダブルクォートをエスケープ
          log.click_count,
          this.calculatePvRatio(log.click_count),
          this.calculateClickRatio(log.click_count)
        ].join(','))
      ].join('\n');

      // BOMを追加してUTF-8として認識させる
      const bom = '\uFEFF';
      const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });

      // ダウンロード実行
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);

      // ファイル名生成
      const fromDate = this.formatDate(this.dateFrom);
      const toDate = this.formatDate(this.dateTo);
      const filterSuffix = this.isFiltered ? `_filtered_${this.currentFilter.replace(/[^a-zA-Z0-9]/g, '_')}` : '';
      link.setAttribute('download', `click_link_logs_${fromDate}_${toDate}${filterSuffix}.csv`);

      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  },
  computed: {
    clickLinkLogs() {
      return this.$store.state[this.state_name].click_link_logs || [];
    },
    dateFrom() {
      return this.$store.state[this.state_name].date_from;
    },
    dateTo() {
      return this.$store.state[this.state_name].date_to;
    },
    totalClicks() {
      return this.clickLinkLogs.reduce((total, log) => total + log.click_count, 0);
    },
    totalPv() {
      return this.$store.state[this.state_name].event_count || 0;
    },
    isLoading() {
      return this.$store.state[this.state_name].click_link_logs_loading || false;
    },
    displayData() {
      return this.isFilterApplied ? this.filteredData : this.clickLinkLogs;
    },
    filteredTotalClicks() {
      return this.displayData.reduce((total, log) => total + log.click_count, 0);
    },
    isFiltered() {
      return this.isFilterApplied;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 1050;
}

.modal-content {
  display: flex;
  flex-direction: column;
  height: 100vh;
  border: 0;
  border-radius: 0;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1020;
  background-color: white;
  border-bottom: 1px solid #dee2e6;
}

.modal-body {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.sticky-info {
  position: sticky;
  top: 0;
  z-index: 1010;
  background-color: white;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 0 !important;
}

.table-container {
  flex: 1;
  overflow-y: auto;
  padding: 0 1rem;
}

.sticky-table-header {
  position: sticky;
  top: 0;
  z-index: 1000;

  th {
    &:hover {
      background-color: inherit !important;
      color: inherit !important;
    }
  }
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  z-index: 1020;
  background-color: white;
  border-top: 1px solid #dee2e6;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: #000;
  opacity: 0.5;

  &:hover {
    opacity: 0.75;
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }

  i {
    font-size: 1rem;
  }
}

.input-group {
  .btn {
    border-left: 0;

    &.btn-outline-secondary {
      border-color: #ced4da;

      &:hover {
        background-color: #6c757d;
        border-color: #6c757d;
        color: white;
      }
    }

    &.btn-outline-danger {
      border-color: #ced4da;

      &:hover {
        background-color: #dc3545;
        border-color: #dc3545;
        color: white;
      }
    }
  }

  .form-control {
    border-right: 0;

    &:focus {
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);

      + .btn {
        border-color: #80bdff;
      }
    }
  }
}

.loading-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

// テーブルの列幅設定
.rank-column {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}

.url-column {
  width: calc(100% - 400px);
  min-width: 250px;
}

.count-column {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

.pv-ratio-column {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

.click-ratio-column {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
}

// URL表示の改善
.url-link {
  display: block;
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
  max-width: 100%;
  text-decoration: none;
  color: #0d6efd;

  &:hover {
    text-decoration: underline;
    color: #0a58ca;
  }
}

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100vh;
  margin: 0;

  .modal-content {
    height: 100vh;
    border: 0;
    border-radius: 0;
  }
}

// スマートフォン対応
@media (max-width: 768px) {
  .rank-column {
    width: 40px;
    min-width: 40px;
    max-width: 40px;
  }

  .count-column {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
  }

  .pv-ratio-column {
    width: 70px;
    min-width: 70px;
    max-width: 70px;
  }

  .click-ratio-column {
    width: 90px;
    min-width: 90px;
    max-width: 90px;
  }

  .url-column {
    width: calc(100% - 280px);
    min-width: 150px;
  }
}
</style>
